import React from "react";

export default function TopBanner(){
    return (
        <div style={{marginBottom:'30px'}}>
            <div className="topbanner">
                
                <p className="topheader">Kshethrasuvidham</p>
            </div>
            
        </div>
    )
}